<template>
<div class="tabLineContainer">
  <!-- <el-row v-if="pageType === 'processParams'" :gutter="20">
    <el-col :span="6" v-for="(tab,index) in tabs" :key="index">
      <div :class="['tabItem' , selectTab === tab.code ? 'active' : '']" @click="tabChange(tab)" v-if="(tab.code === 'Process'&&rolePermit('craft:query')) ||(tab.code === 'Program'&&rolePermit('burning:query')) ||(tab.code === 'ItemNumber'&&rolePermit('material:query'))"><span>{{tab.name}}</span></div>
    </el-col>
  </el-row>
  <el-row v-if="pageType === 'systemM'" :gutter="20">
    <el-col :span="6" v-for="(tab,index) in tabs" :key="index">
      <div :class="['tabItem' , selectTab === tab.code ? 'active' : '']" @click="tabChange(tab)" v-if="(tab.code === 'RoleM'&&rolePermit('role:query')) || (tab.code === 'PersonM'&&(rolePermit('employee:query') && rolePermit('org:query'))) ||(tab.code === 'LogM'&&rolePermit('syslog:query'))||tab.code === 'SystemSet'"><span>{{tab.name}}</span></div>
    </el-col>
  </el-row> -->
  <el-row :gutter="20">
    <!-- <el-col :span="4" v-for="(tab,index) in tabs" :key="index">
      <div :class="['tabItem' , selectTab.code === tab.code ? 'active' : '']" @click="tabChange(tab)"><span>{{tab.name}}</span></div>
    </el-col> -->
    <el-col :span="3" v-for="(tab,index) in tabs" :key="index">
      <div :class="['tabItem' , selectTab.code === tab.code ? 'active' : '']" @click="tabChange(tab)"><span>{{tab.name}}</span></div>
    </el-col>
  </el-row>
</div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => {
        return []
      }
    },
    pageType: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      selectTab: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // console.log(this.pageType)
      // if (this.pageType === 'processParams') {
      //   if (this.rolePermit('craft:query')) {
      //     this.selectTab = this.tabs[0].code
      //     console.log(this.selectTab)
      //     this.$emit('tabToggle', this.selectTab)
      //   } else if (this.rolePermit('burning:query')) {
      //     this.selectTab = this.tabs[1].code
      //     this.$emit('tabToggle', this.selectTab)
      //   } else if (this.rolePermit('material:query')) {
      //     this.selectTab = this.tabs[2].code
      //     this.$emit('tabToggle', this.selectTab)
      //   }
      // } else if (this.pageType === 'systemM') {
      //   if (this.rolePermit('role:query')) {
      //     this.selectTab = this.tabs[0].code
      //     this.$emit('tabToggle', this.selectTab)
      //   } else if (this.rolePermit('employee:query') && this.rolePermit('org:query')) {
      //     this.selectTab = this.tabs[1].code
      //     this.$emit('tabToggle', this.selectTab)
      //   } else if (this.rolePermit('syslog:query')) {
      //     this.selectTab = this.tabs[2].code
      //     this.$emit('tabToggle', this.selectTab)
      //   }
      // }
      this.selectTab = this.tabs[0]
      this.$emit('tabToggle', this.selectTab)
    },
    tabChange(tab) {
      this.selectTab = tab
      this.$emit('tabToggle', this.selectTab)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabLineContainer {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin-bottom: 15px;
  border-bottom: 1px solid #DEDEDE;
  .tabItem {
    background: #fff;
    text-align: center;
    cursor: pointer;
    // box-shadow: 0px 0px 30px 0px rgba(220, 236, 248, 0.69);
    // border-radius: 2px;
    position: relative;
    top: 1px;
    span {
      display: inline-block;
      line-height: 36px;
      height: 36px;
      font-size: 14px;
      box-sizing: border-box;
      // color: #999B9E;
      color: #333;
      font-weight: 500;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    }

    &.active {
      border: 1px solid #DEDEDE;
      border-bottom: none;
      border-top: 2px solid #1089FF;
      span {
        color: #1089FF;
        // border-bottom: 2px solid #1089FF;
      }
    }
  }
}
</style>
<style lang="scss">
.mainContent{
  .el-breadcrumb{
    padding-bottom: 15px;
  }
  .tabBox{
    .tabLineContainer{
      .el-col{
        padding: 0 5px !important;
      }
      .el-col-3{
        width: 10%;
      }
    }
  }
}
</style>
